import { DashboardRouter } from "../dashboard.router";

export class CreatePatientRecordRouter {
    
    static getRoute(): string {
        return `${DashboardRouter.getRoute()}/create-patient-record`
    }

}